import {
  CHECKOUT_SELECT_PAYMENT_HELPER_COPY,
  ESTIMATED_WEIGHT_EMPTY_INTERSECTION_COPY,
} from './constants';
import { RegularPaymentMethod } from './get-checkout-payment-availability';

export type CheckoutAllowedPaymentMethod =
  | 'term_of_payment'
  | RegularPaymentMethod;

export function readAllowedCheckoutPaymentMethod(
  paymentMethod: string
): CheckoutAllowedPaymentMethod | undefined {
  if (
    paymentMethod === 'term_of_payment' ||
    paymentMethod === 'cash_on_delivery' ||
    paymentMethod === 'bank_transfer'
  ) {
    return paymentMethod;
  }

  return undefined;
}

function isRegularPaymentAllowed(
  paymentMethod: string,
  allowedMethods: readonly RegularPaymentMethod[]
): boolean {
  if (paymentMethod === 'term_of_payment') {
    return true;
  }

  if (
    paymentMethod !== 'cash_on_delivery' &&
    paymentMethod !== 'bank_transfer'
  ) {
    return false;
  }

  return allowedMethods.includes(paymentMethod);
}

export function getCheckoutSubmitState({
  paymentMethod,
  isOrderSubmitted,
  isEmptyIntersection,
  allowedMethods,
  fieldErrorMessage,
}: {
  paymentMethod: string;
  isOrderSubmitted: boolean;
  isEmptyIntersection: boolean;
  allowedMethods: readonly RegularPaymentMethod[];
  fieldErrorMessage: string | null;
}): {
  canSubmit: boolean;
  helperMessage: string | null;
} {
  const canSubmit =
    Boolean(paymentMethod) &&
    !isOrderSubmitted &&
    !isEmptyIntersection &&
    isRegularPaymentAllowed(paymentMethod, allowedMethods);

  if (!paymentMethod) {
    return {
      canSubmit,
      helperMessage: CHECKOUT_SELECT_PAYMENT_HELPER_COPY,
    };
  }

  if (isEmptyIntersection && paymentMethod !== 'term_of_payment') {
    return {
      canSubmit,
      helperMessage: ESTIMATED_WEIGHT_EMPTY_INTERSECTION_COPY,
    };
  }

  return {
    canSubmit,
    helperMessage: fieldErrorMessage,
  };
}
